import TagList, { type Tag } from "core/components/Tag";
import { _t } from "core/language";
import Section from "core/components/Section";
import ProductListItem from "core/components/ProductListItem";
import { RouterName } from "core/router";
import {
  useRecipes,
  useGoToRecipeDetail,
  useUpdateFavorite,
} from "./../../hooks/recipe";
import { getYouTubeThumbnail } from "core/utils/helper";
import InfiniteScroll from "react-infinite-scroll-component";
// import RecipeSuggestionItemLoading from './Loading'
import RecipeSuggestionItemLoadingSpin from "./LoadingSpin";
import LoadingAI from "modules/AiChef/components/Loading";
import CoupangBanner from "core/components/Coupang/CoupangBanner";

const RecipeSuggestions = ({ ingredients, options, keyword, isIgnoreIds }: any) => {
  const goToDetail = useGoToRecipeDetail(RouterName.INGREDIENT_RECIPE_DETAIL);
  const {
    loading,
    data,
    loadMore,
    reload,
    params,
    recipeRequestId,
    recipeRequestError,
    searchRequestId,
  } = useRecipes(
    ingredients,
    options,
    keyword,
    isIgnoreIds
  );
  const onUpdateFavorite = useUpdateFavorite();

  const ingredientOptions =
    ingredients?.map(
      (e: any) => ({ id: String(e.id), text: e.name } as Tag)
    ) || [];

  return (
    <div>
      <Section className="py-[20px]">
        <TagList
          label={_t("recipe.selected_ingredients")}
          options={ingredientOptions}
          value={ingredientOptions.map((e: Tag) => e.id)}
          className="mx-auto min-w-0"
          labelClassName="block mb-[10px] text-[16px] px-4 font-medium"
          listClassName="px-4"
          itemInline
        />
      </Section>
      <Section className="px-4 pt-[30px]">
        <label className="block mb-3.5 text-[16px] font-medium">
          {_t("recipe.recommend")}
        </label>
        <InfiniteScroll
          dataLength={data.length}
          next={loadMore}
          hasMore={!!data.length && !keyword && !searchRequestId}
          loader={null}
          className="grid grid-cols-2 gap-x-2"
          scrollThreshold={1}
        >
          {/* CoupangBanner */}
          {/* <CoupangBanner /> */}
          {data.map((item: any, idx: number) => (
            <>
              <ProductListItem
                key={item.id}
                recipeRequestId={recipeRequestId}
                handleClick={() => goToDetail(item)}
                handleClickNote={onUpdateFavorite}
                reload={(cb: any) => reload(cb, item.id)}
                showNote
                active={!!item.is_favorite}
                dataItem={item}
                name={item.name}
                image={item.thumbnail || getYouTubeThumbnail(item.video_id)}
                type={1}
                className="mb-[20px]"
              />
              {
                //check if item is 10th item, show banner
                (idx === 5 || idx === 25 || idx === 65) ? (
                  <>
                    <div className="col-span-2 w-[calc(100% - 32px)] mb-4">
                      <CoupangBanner index={idx}/>
                    </div>
                  </>
                ) : null
              }
            </>
          ))}
        </InfiniteScroll>
        {recipeRequestError ? (
          <div className="text-center text-red-500">
            {recipeRequestError.msg}
          </div>
        ) : null}
        {(loading && !recipeRequestError) ? (
          params.page === 1 ? (
            <LoadingAI />
          ) : (
            <RecipeSuggestionItemLoadingSpin />
          )
        ) : null}
      </Section>
    </div>
  );
};

export default RecipeSuggestions;
